var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.504 10.65 10.008 19l-7.496-8.35a5.7 5.7 0 0 1-1.144-1.911 6.3 6.3 0 0 1-.366-2.266 6.2 6.2 0 0 1 .472-2.241 5.6 5.6 0 0 1 1.232-1.84 4.9 4.9 0 0 1 1.784-1.13 4.5 4.5 0 0 1 2.037-.23 4.6 4.6 0 0 1 1.949.708c.6.385 1.12.905 1.532 1.528a5.2 5.2 0 0 1 1.535-1.515 4.6 4.6 0 0 1 1.945-.698c.684-.08 1.375 0 2.03.235.656.234 1.26.619 1.778 1.128a5.6 5.6 0 0 1 1.228 1.835 6.249 6.249 0 0 1 .114 4.494 5.7 5.7 0 0 1-1.134 1.91"
  })));
};
export default SvgHeart;